const ValidateDocumentActionTypes = {
  VALIDATE_DOCUMENT_REQUEST: 'VALIDATE_DOCUMENT_REQUEST',
  VALIDATE_DOCUMENT_SUCCESS: 'VALIDATE_DOCUMENT_SUCCESS',
  VALIDATE_DOCUMENT_FAILURE: 'VALIDATE_DOCUMENT_FAILURE'
}

export default ValidateDocumentActionTypes